module.exports = __webpack_public_path__ + "img/full3-min.09a33b4d.png";